import React, { useState, useEffect } from 'react';
import { contentAPI } from '../services/api';

const HeroSection = () => {
  // Get first award data for static display (no carousel)
  const [award, setAward] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAwards = async () => {
      try {
        const data = await contentAPI.getAwards();
        if (data && data.length > 0) {
          setAward(data[0]); // Use first award only
        }
      } catch (error) {
        console.error('Error fetching awards:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchAwards();
  }, []);

  const scrollToContent = () => {
    window.scrollTo({
      top: window.innerHeight,
      behavior: 'smooth'
    });
  };

  if (loading || !award) {
    return (
      <section className="relative min-h-[700px] flex items-center justify-center overflow-hidden bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900">
        <div className="text-white text-xl">Loading...</div>
      </section>
    );
  }

  return (
    <section className="relative min-h-[700px] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img 
          src="/hero-background.jpeg" 
          alt="Hero Background" 
          className="w-full h-full object-cover brightness-110 hue-rotate-15"
        />
        {/* Blue-tinted overlay for natural sky blue */}
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900/50 via-blue-600/20 to-blue-400/10" />
      </div>

      {/* Content - Positioned to avoid covering people */}
      <div className="container mx-auto px-4 lg:px-8 relative z-10 py-20">
        <div className="max-w-3xl text-left lg:text-left">
          {/* Concise Combined Title */}
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-8 leading-tight">
            Empowering Business Growth with{' '}
            <span className="whitespace-nowrap">SAP Business One</span>
          </h1>

          {/* Scroll Indicator - Centered Arrows */}
          <button
            onClick={scrollToContent}
            className="group inline-flex items-center space-x-3 cursor-pointer hover:opacity-80 transition-opacity"
          >
            <span className="text-white text-base font-medium tracking-wide">
              Start Your Ascarii Journey
            </span>
            <div className="flex items-center">
              <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 13l-7 7-7-7M19 6l-7 7-7-7" />
              </svg>
            </div>
          </button>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;